import { AppHeaderComponent } from './app-header/app-header.component';
import { AppNotificationComponent } from './app-notifications/app-notification/app-notification.component';
import { AppNotificationsComponent } from './app-notifications/app-notifications.component';
import { AppSidebarComponent } from './app-sidebar/app-sidebar.component';
import { AppViewComponent } from './app-view/app-view.component';
import { SplashViewComponent } from './splash-view/splash-view.component';

export const allComponents = [
  AppHeaderComponent,
  AppNotificationComponent,
  AppNotificationsComponent,
  AppSidebarComponent,
  AppViewComponent,
  SplashViewComponent,
];
export const publicComponents = [
  AppNotificationComponent,
  AppNotificationsComponent,
  AppViewComponent,
];

export * from './app-header';
export * from './app-sidebar';
export * from './app-view';
export * from './splash-view';
